"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.if$ = void 0;
const if$ = (is, x, y) => is ? x : y;
exports.if$ = if$;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaWYuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvaWYudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQU8sTUFBTSxHQUFHLEdBQUcsQ0FBUyxFQUFXLEVBQUUsQ0FBSyxFQUFFLENBQUssRUFBRSxFQUFFLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztBQUF4RCxRQUFBLEdBQUcsT0FBcUQifQ==